<template>
  <v-sheet color="var(--c-white)" class="gIl mt-4 mb-2 pb-10">
    <v-row
      v-masonry="$route.fullPath"
      transition-duration="0.3"
      item-selector=".gIl-Unit"
      class="mx-2 mx-sm-0"
    >
      <v-col
        v-masonry-tile="$route.fullPath"
        class="gIl-Unit d-flex justify-center"
        v-for="item in illustList"
        :key="item.shouhinId"
        cols="6"
        sm="4"
        md="3"
        lg="2"
      >
        <v-card width="100%" flat>
          <v-card
            class="gIl-Card mx-0 sw-Pointer mx-auto"
            max-width="240px"
            outlined
            :height="cardHeight"
            :to="{
              name: 'gallery-detail',
              params: { itemId: item.shouhinId },
            }"
          >
            <v-img
              class="mx-auto"
              width="auto"
              min-height="100px"
              :src="`${objectPath}/images/main/${item.shouhinId}/thumb/thumbnail/${item.shouhinId}.webP`"
              @load="masonry()"
            >
              <template v-slot:placeholder>
                <v-sheet
                  height="100%"
                  class="d-flex justify-center align-center"
                >
                  <v-progress-circular
                    indeterminate
                    color="var(--gray-2)"
                  ></v-progress-circular>
                </v-sheet>
              </template>
            </v-img>
            <div class="gIl-Btn"></div>
          </v-card>

          <v-list-item v-if="screenType == 1" class="pa-0">
            <v-list-item-avatar class="mr-2">
              <BaseIcon size="40" :itemId="item.characterIcon" />
            </v-list-item-avatar>
            <!-- </router-link> -->
            <v-list-item-content>
              <v-list-item-title class="fs-xs font-weight-bold lh-l">
                <v-icon small>palette</v-icon>
                <router-link
                  class="sw-Link-primary"
                  :to="{
                    name: 'creator-detail',
                    params: { creatorKbn: 1, creatorId: item.creatorId },
                  }"
                  >{{ item.creatorName }}
                </router-link>
              </v-list-item-title>
              <v-list-item-subtitle class="fs-xs sw-Link-primary">
                <router-link
                  class="sw-Link-primary"
                  :to="{
                    name: 'portalSearchResult-noWord',
                    params: { type: 'illust' },
                    query: { shouhinKbn: item.shouhinKbn },
                  }"
                >
                  {{ item.shouhinmei }}</router-link
                >
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
export default {
  name: "galleryIllustList",
  props: {
    illustList: {
      mode: Array,
      required: true,
    },
    // 0：デフォルト、1:検索結果
    screenType: {
      mode: Number,
      required: false,
      default: 0,
    },
  },
  computed: {},
  mounted() {
    if (typeof this.$redrawVueMasonry === "function") {
      this.$redrawVueMasonry(this.$route.fullPath);
    }
  },
  watch: {},
  data() {
    return {
      cardHeight: "auto",
      itemCount: 0,
    };
  },

  methods: {
    masonry() {
      this.$nextTick(function () {
        this.$redrawVueMasonry(this.$route.fullPath);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/sass/import.scss";

.gIl {
  // &-Unit {
  //   top: 100%;
  //   left: 100%;
  // }
  &-Card {
    display: grid;
    align-items: center;
    overflow: hidden;
    &:hover {
      .v-image {
        opacity: 0.8;
      }
    }
    .v-image {
      transition: opacity 0.2s ease-in-out;
    }
  }
  &-Btn {
    position: absolute;
    right: 8px;
    bottom: 8px;
  }
}
</style>
